import React from 'react';

import { IBdsLinearProgressIndicator } from '../../../interfaces/bdsLinearProgressIndicator';
import './BdsLinearProgressIndicator.scss';

const BdsLinearProgressIndicator = ({ progress, variant, size, width = 100 }: IBdsLinearProgressIndicator) => {
  const bdsLinearProgressIndicator = ['bds-linear-progress-indicator', size, variant].join(' ');
  const bdsLinearProgressIndicatorProgressbar = ['bds-linear-progress-indicator-bar', variant].join(' ');
  const clampedProgress = Math.min(100, Math.max(0, progress));
  return (
    <div className={bdsLinearProgressIndicator} style={{ width: `${width}%` }}>
      <div className={bdsLinearProgressIndicatorProgressbar} style={{ width: `${clampedProgress}%` }}></div>
    </div>
  );
};

export default BdsLinearProgressIndicator;
